// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 273) return "static/chunks/273-b87d1ecd81bcee2c.js";
	if (chunkId === 523) return "static/chunks/523-cc7bd8242e33c63a.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"254":"56c12eb5","970":"lottie"}[chunkId] || chunkId) + "." + {"108":"0237b73660167fd2","254":"2f8f141ea937ab4a","887":"fcd3abbabc0d1546","970":"361a578344e8f4df"}[chunkId] + ".js";
};